import { Navigate, useParams } from "react-router-dom";
import CompanyTemplate from "@/components/site/CompanyTemplate";
import { companyBySlug } from "@/data/content";

export default function CompanyPage() {
  const { slug } = useParams();
  const company = companyBySlug(slug);
  if (!company) return <Navigate to="/companies" replace />;
  return <CompanyTemplate company={company} />;
}
